import { render, staticRenderFns } from "./DisappearingComponent.vue?vue&type=template&id=5640b1cc&scoped=true"
import script from "./DisappearingComponent.vue?vue&type=script&lang=js"
export * from "./DisappearingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5640b1cc",
  null
  
)

export default component.exports